import React from 'react';
import { useNavigate } from "react-router-dom";
import { DataGrid } from '@mui/x-data-grid';
import {Box, Grid, Button} from '@material-ui/core';
import {OutlinedInput, FormControl, Stack, Snackbar, Alert, LinearProgress, Radio, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import {MetaTags} from 'react-meta-tags';
import axios from 'axios';
import Cookies from 'js-cookie';
import Tooltip from '@mui/material/Tooltip';
import Authorization from '../components/Authorization';
import InvoicesTypesSave from './InvoicesTypesSave';
import { useSelector } from 'react-redux';
import {API_URL} from '../utils/EnvVars';
import Header from "../common/HeaderMy";
///import moment from 'moment';
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';

  
  var vertical='top',horizontal='center';
  
  export default function Execute() {
	const navigate = useNavigate();
	const userObj = useSelector(state => state.userDetails);	
	const isloggedin = Cookies.get('isrwadminloggedin');
	const childRefSave = React.useRef();
	const childRefAuthorization = React.useRef();
	const [privileges, setPrivileges] = React.useState("");
	const [dataLoading, setDataLoading] = React.useState(true);
	const [deleteDialogShow, setDeleteDialogShow] = React.useState(false);
	const [filter, setFilter] = React.useState(false);
	const [keyword, setKeyword] = React.useState("");
	const [dataObj, setDataObj] = React.useState({});
	const [rows, setRows] = React.useState([]);
	const [selectedRow, setSelectedRow] = React.useState(0);

	///const [open, setOpen] = React.useState(false); 
	const [severityAlert, setSeverityAlert] = React.useState("error");
	const [showAlert, setShowAlert] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");
  

	var myCurrentDate=new Date();
	var myPastFromDate=new Date(myCurrentDate);
    myPastFromDate.setDate(myPastFromDate.getDate() - 366);

	function hideAlert(){
		setShowAlert(false);
	}

	const columns = [
		{
			field: "Select",
			headerName: "",
			width: 90,
			sortable: false,
				renderCell: (cellValues) => {
				return (
				  <Radio 
					checked={cellValues.id === selectedRow}
					value={cellValues.id}
					name="radio-buttons"
					inputProps={{ 'aria-label': {cellValues} }}
				  />
				 )
			  }
		  },
		{ field: 'id', headerName: 'Sr. No.', width: 40 },
		{ field: 'invoiceName', headerName: 'Type', width: 200, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'serialNumberStart', headerName: 'Serial Number', flex: 1, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'affixNumber', headerName: 'Affix Number', flex: 1, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'active', headerName: 'Active', flex: 1, renderCell: (params) => {
			return <span>{params.value===1?<><i className="fa fa-check-square-o" style={{fontSize:15}} ></i></>:<><i className="fa fa-square-o" style={{fontSize:15}} ></i></>}</span>
		  },
		},   
		{ field: 'lastModifiedDateTime', headerName: 'Modified Date/Time', flex: 1, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },   
		{ field: 'lastModifiedAlias', headerName: 'Modified By', flex: 1, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), }  
	  ];
	

	// check if logged in
	React.useEffect(() => {
		if(!isloggedin){
			navigate('/login');
		}
	}, [isloggedin]);

	React.useEffect(() => {		
		if(userObj.registerId && userObj.loginId && userObj.fullName && userObj.token){
			getApiData(userObj.registerId,userObj.loginId,userObj.fullName,userObj.token);
		}
	}, [userObj,filter]);

	async function getApiData(registerId,uid,fullName,token){ 
		  let apiUrl=API_URL+'/crm-invoices-types?keyword='+keyword;
		  let axiosHeader = {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': registerId,
					'uid': uid,
					'fullName': fullName,
					'token': token,
			};
			const config = {
				method: 'get',
				url: apiUrl,
				headers: axiosHeader
			}
			await axios(config)
			   .then(response => {
				setDataLoading(false);
				if(response && response.data && response.data.responseTxt==="success"){  
				 	setRows(response.data.list);			
					 setPrivileges(response.data.privileges);	 				
				}else if(response && response.data && response.data.responseTxt==="invalidtoken"){
					navigate('/invalidtoken');					
				}else if(response && response.data && response.data.responseTxt==="NoAuthorization"){
					childRefAuthorization.current.handleClickOpen();
				}
			})
	}

	function deleteData(){
		if(dataObj && dataObj!=null && userObj){
			let apiUrl=API_URL+'/crm-delete-invoices-types';
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': userObj.registerId,
					'uid': userObj.loginId,
					'fullName': userObj.fullName,
					'token': userObj.token,
				}
			};
  
		  const data = new FormData();
		  data.append('id', dataObj.autoId);				 
		  axios.post(apiUrl, data, axiosHeader)
				.then((response) => {
					///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
					setDeleteDialogShow(false);
				if(response.data.responseTxt==="success"){
					setSelectedRow(0);
					setDataObj(null);
					setSeverityAlert("success");
					///setOpen(false);
					setShowAlert(true);
					setAlertMessage("Invoice type has been deleted.");
			  		setRows(response.data.list);	
					return false;
				}else{
			  		setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("This invoice type could not be deleted.");			
					return false;
				}
			})
			.catch((error) => {
				setSeverityAlert("error");
				setShowAlert(true);
				setAlertMessage(" "+error);			
				return false;
			})	
		}		
	
		
	}

	function saveData(opt){
		if(opt===1){
			setDataObj(null);
		}	
		childRefSave.current.handleClickOpen();
	}
	
	function selectRow(obj){
		if(obj && rows[obj.id-1]){			
			setSelectedRow(rows[obj.id-1].id);
			setDataObj(rows[obj.id-1]);
			///childRef.current.handleClickOpen();
		}
	}

	function search(){
		setFilter(!filter);
	}

	function onEnter(event){
		if(event.key === 'Enter'){
			search();
		}
	}
	
	function deleteDialogHide(){
		setDeleteDialogShow(false);
	}

	function updatedList(list) {
		setRows(list);
	}

	return (
		<div> 
				<MetaTags>
            		<title>Invoice Types</title>
          		</MetaTags>
				
				<Header hamburger={true} pageTitle="Invoice Types" />
				{dataLoading?<LinearProgress />:null}

				<Box className='mainBox'>	

				<Box mt={1} mb={1} >
							<Grid container spacing={2}>
								<Grid item md={12} xs={12} >

									<FormControl style={{width:150,marginRight:60,float:'left'}}>
										<OutlinedInput 
										 id="keywordtxt"
										 placeholder="Search"
										 value={keyword}
										 onChange={event => setKeyword(event.target.value)}
										 onKeyPress={(event)=>{onEnter(event)}}
										 style={{width:200,height:40}}
										 />
									</FormControl>

									<Button onClick={() => {search()}} style={{marginTop:4,float:'left',backgroundColor:'#FFF',textTransform: 'none'}} size="small" variant="contained"  >Search</Button>

									<div style={{float:'left'}}>	
										{(privileges && privileges.indexOf("create")>-1)?
											<i onClick={()=>{saveData(1)}} title="Add New" className="fa fa-plus-circle btncolor" style={{fontSize:30, marginLeft:15, cursor:'pointer'}} />
										:null}
									{selectedRow>0?<>	
										{(privileges && privileges.indexOf("update")>-1)?
											<i onClick={()=>{saveData(2)}} title="Edit" className="fa fa-pencil-square-o btncolor" style={{fontSize:30, marginLeft:15, cursor:'pointer'}} />
										:null}
										{(privileges && privileges.indexOf("delete")>-1)?
											<i onClick={()=>{setDeleteDialogShow(true)}} title="Delete" className="fa fa-trash btncolor" style={{fontSize:30, marginLeft:15, cursor:'pointer'}} />
										:null}
									</>:null}	

									</div>	
								</Grid>
							</Grid>
					</Box>

					<div className="tblReport" style={{height: '78vh', width: '100%' }}>
						<DataGrid
							rows={rows}
							columns={columns}
							pageSize={50}
							rowHeight={40}
							rowsPerPageOptions={[50]}
							ActionsComponent={()=>{alert('Hello')}}		
							style={{fontSize:12}}
							components={{
								NoRowsOverlay: () => (
								  <Stack height="100%" alignItems="center" justifyContent="center">
									<span style={{color:'#FF0000',fontWeight:'bold'}}>No records found!</span>
								  </Stack>
								)}}	
							onRowClick={itm => selectRow(itm)}	
						/>
					</div>

				</Box>

			<InvoicesTypesSave dataObj={dataObj} updatedList={updatedList} ref={childRefSave} />

			<Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
			</Stack>

				<Dialog
					open={deleteDialogShow}
					onClose={deleteDialogHide}
					aria-labelledby="alert-dialog-section-title"
					aria-describedby="alert-dialog-section-description"
				>
					<DialogTitle id="alert-dialog-section-title">
						Alert
					</DialogTitle>
					<DialogContent>
					<DialogContentText style={{width:280}} id="alert-dialog-section-description">
						Are you sure, You want to delete.
					</DialogContentText>
					</DialogContent>
					<DialogActions>
					<Button variant="outlined" size="small" onClick={()=>{deleteDialogHide()}}>Don't Delete</Button>
					<Button variant="contained" size="small" color="secondary" onClick={()=>{deleteData()}} autoFocus>Yes, Delete</Button>
					</DialogActions>
				</Dialog>

				<Authorization ref={childRefAuthorization} />
		</div>	
	);
  }